export const TypeEnum = {
    CREATE_YEAR: "CREATE_YEAR",    // 新增年度
    SHOW_YEAR: "SHOW_YEAR",        // 显示年度列表
    DEL_YEAR: "DEL_YEAR",          // 删除年度

    CREATE_LIFE: "CREATE_LIFE",    // 发布故事
    SHOW_LIFE: "SHOW_LIFE",        // 显示故事列表
    DEL_LIFE: "DEL_LIFE",          // 删除故事
    CREATE_LIFE_TYPE: "CREATE_LIFE_TYPE",  // 发布故事类别
    SHOW_LIFE_TYPE: "SHOW_LIFE_TYPE",      // 显示故事类别列表
    DEL_LIFE_TYPE: "DEL_LIFE_TYPE",        // 删除故事类别

    CREATE_MUSIC: "CREATE_MUSIC",  // 发布音乐
    SHOW_MUSIC: "SHOW_MUSIC",      // 显示音乐列表
    DEL_MUSIC: "DEL_MUSIC",          // 删除音乐

    CREATE_INSTR: "CREATE_INSTR",  // 发布工具
    SHOW_INSTR: "SHOW_INSTR",      // 显示工具列表
    DEL_INSTR: "DEL_INSTR",          // 删除工具
    CREATE_INSTR_TYPE: "CREATE_INSTR_TYPE",  // 发布工具类别
    SHOW_INSTR_TYPE: "SHOW_INSTR_TYPE",      // 显示工具类别列表
    DEL_INSTR_TYPE: "DEL_INSTR_TYPE",        // 删除工具类别

    SHOW_DANMAKU: "SHOW_DANMAKU",      // 显示弹幕列表
    DEL_DANMAKU: "DEL_DANMAKU",          // 删除弹幕
    SHOW_COMMENT: "SHOW_COMMENT",      // 显示评论列表
    DEL_COMMENT: "DEL_COMMENT",          // 删除评论

    CREATE_ABLUM: "CREATE_ALBUM",      // 发布相册
    SHOW_ALBUM: "SHOW_ALBUM",          // 显示相册列表  
    DEL_ALBUM: "DEL_ALBUM",            // 删除相册
    CREATE_ABLUM_TYPE: "CREATE_ALBUM_TYPE",  // 发布相册类别
    SHOW_ALBUM_TYPE: "SHOW_ALBUM_TYPE",      // 显示相册类别列表
    DEL_ALBUM_TYPE: "DEL_ALBUM_TYPE",        // 删除相册类别

    CREATE_FRIEND_LINK: "CREATE_FRIEND_LINK",      // 发布友链
    SHOW_FRIEND_LINK: "SHOW_FRIEND_LINK",          // 显示友链列表
    DEL_FRIEND_LINK: "DEL_FRIEND_LINK",          // 删除友链

    CREATE_TRAVELS: "CREATE_TRAVELS",      // 发布游记
    SHOW_TRAVELS: "SHOW_TRAVELS",          // 显示游记列表
    DEL_TRAVELS: "DEL_TRAVELS",          // 删除游记

    SYS_CONFIG: "SYS_CONFIG",          // 系统全局配置
    CURATED_ALBUM: "CURATED_ALBUM"     // 精选相册

}